<template>
  <div class="simple">
    <div class="left_body">
      <div class="column" style="display:flex; margin-right:10px; margin-bottom:50px;">
        <tw-status-bar v-if="typeof tradeManagement.processProgressStatus === 'number'" :statusCode="tradeManagement.processProgressStatus" :approval="approvalProcess" />
        <tw-from-to :from="from" :to="to" :editableSide="tradeManagement.responsibleFlg === RESPONSIBLE_FLG.FROM ? 'from' : 'to'" :processProgressStatus="tradeManagement.processProgressStatus" style="margin-left: 20px" />
      </div>
      <el-select v-if="isArchive" v-model="version" @change="changeVersion" placeholder="Select" style="width: 120px;margin-bottom: 22px">
        <el-option
          v-for="version in versions"
          :key="version.version"
          :label="version.version"
          :value="version.processTrx">
        </el-option>
      </el-select>
      <tw-approval-request v-if="needApprovalArea" :tradeManagement="tradeManagement" />
      <div class="column">
        <div v-if="!isEditMode" class="process_buton">
          <tw-button v-if="needApplyButton" type="primary" size="small" @click="approvalRequest">{{ applyButtonLabel }}</tw-button>
          <tw-button v-if="needRegisterButton" type="primary" size="small" @click="register">{{$t('Label.Register')}}</tw-button>
          <tw-button v-if="needEditButton" type="secondary" size="small" icon="edit" @click="edit">{{$t('Label.Edit')}}</tw-button>
          <el-dropdown trigger="click" placement="bottom-start" @command="onDropDownClick" :tabindex="-1">
            <tw-button v-show="needMenuButton" class="menu_button" type="secondary" size="small" icon="menu">Menu</tw-button>
            <el-dropdown-menu>
              <el-dropdown-item v-if="needReturnButton" command="return">{{$t('Label.Return')}}</el-dropdown-item>
              <el-dropdown-item v-if="needWithdrawButton" command="withdraw">{{$t('Label.Withdraw')}}</el-dropdown-item>
              <el-dropdown-item v-if="needCancelDeleteRequestButton" command="cancelDeleteRequest">{{$t('Label.Cancel')}}</el-dropdown-item>
              <el-dropdown-item v-if="needFromDeleteButton" command="fromDeleteRequest">{{$t('Label.Delete')}}</el-dropdown-item>
              <el-dropdown-item v-if="needToDeleteButton" command="toDeleteRequest">{{$t('Label.Delete')}}</el-dropdown-item>
              <el-dropdown-item v-if="needDeleteSavedDataButton" command="deleteSavedData">{{$t('Label.Delete Save Data')}}</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div v-if="isEditMode" class="process_buton">
          <tw-button v-if="editNeedSaveButton" type="secondary" size="medium" @click="editSave">{{$t('Label.Save')}}</tw-button>
          <tw-button v-if="editNeedApplyButton" type="primary" size="medium" @click="editApprovalRequest">{{ applyButtonLabel }}</tw-button>
          <tw-button v-if="editNeedRegisterButton" type="primary" size="medium" @click="editRegister">{{$t('Label.Register')}}</tw-button>
        </div>
      </div>
      <el-form :model="localValue" :rules="rules" ref="simpleForm">
        <template v-for="tbl in (schemas.tables || [])">
          <template v-for="grp in (tbl.groups || [])">
            <template v-if="isEditMode">
              <tw-process-group-list-edit-simple v-for="item in grp.children" :key="item.key" :item="item" :tableName="tbl.variableName" :groupName="grp.variableName" v-model="localValue"/>
            </template>
            <template v-else>
              <tw-process-group-list-item-simple v-for="item in grp.children" :key="item.key" :item="item" :tableName="tbl.variableName" :groupName="grp.variableName" :value="localValue"/>
            </template>
          </template>
        </template>
      </el-form>
    </div>
    <div class="center_body">
      <tw-communication @reconfirm="reconfirm" classMode="simple"/>
    </div>
    <div class="right_body">
      <tw-documents classMode="simple" @update-attached-files="updateAttachedFiles" @save="(action, documents) => $emit('save', action, documents)" @approval-request="(action, documents) => $emit('approval-request', action, documents)" />
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import { PROCESS_OPERATION, RESPONSIBLE_FLG, ABLE_FLG, PROCESS_TYPE, PROCESS_PROGRESS_STATUS} from 'lib-tw-common';
import TwCommunication from '@/components/organisms/TwCommunication';
import TwDocuments from '@/components/organisms/TwDocuments';
import TwApprovalRequest from '@/components/organisms/TwApprovalRequest';
import TwButton from '@/components/atoms/TwButton';
import TwStatusBar from '@/components/atoms/TwStatusBar';
import TwFromTo from '@/components/molecules/TwFromTo';
import TwProcessGroupListEditSimple from '../molecules/TwProcessGroupListEditSimple.vue';
import TwProcessGroupListItemSimple from '../molecules/TwProcessGroupListItemSimple.vue';


export default {
  name: 'TwProcessDetailSimple',
  inject: ['s'],
  provide() {
    return {
      s: this.s,
      activeTab: {value: 0},
      tab: 0,
    };
  },
  props: {
    schemas: Object,
    value: Object,
    isArchive: Boolean,
    versions: Array,
    versionNo: [String, Number],
    from: Object,
    to: Object,
    roles: Object,
    tradeManagement: Object,
    bcStatus: Number,
    approvalProcess: Boolean,
    processId: String,
    processType: String,
    rules: Object,
    initialOpen: {
      type: Boolean,
      default: false,
    },
  },
  components: { 
    TwCommunication,
    TwDocuments,
    TwApprovalRequest,
    TwButton,
    TwStatusBar,
    TwFromTo,
    TwProcessGroupListItemSimple,
    TwProcessGroupListEditSimple
  },
  data() {
    return {
      version: this.versionNo ? parseInt(this.versionNo) : null,
      isEditMode: false,
      RESPONSIBLE_FLG
    };
  },
  computed: {
    localValue: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      }
    },
    // To下書き削除ボタンの表示可否を返却します
    needDeleteSavedDataButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }

      return !this.tradeManagement.eventCancel && this.tradeManagement.actions.includes(PROCESS_OPERATION.T_SAVING_DEL);
    },
    // ToDeleteボタンの表示可否を返却します
    needToDeleteButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }

      return this.tradeManagement.eventCancel && this.tradeManagement.actions.includes(PROCESS_OPERATION.T_SAVING_DEL);
    },
    // FromDeleteボタンの表示可否を返却します
    needFromDeleteButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }

      return this.tradeManagement.actions.includes(PROCESS_OPERATION.F_SAVING_DEL);
    },
    // 削除取り消しボタンの表示可否を返却します
    needCancelDeleteRequestButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }
      return this.tradeManagement.eventCancel && this.tradeManagement.actions.includes(PROCESS_OPERATION.F_PULL_BACK);
    },
    // Withdrawボタンの表示可否を返却します
    needWithdrawButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }

      // Todo: APIのtradeManagement.actionsでAGREEDステータスのCO申請にPROCESS_OPERATION.F_PULL_BACKの値が返却されないよう修正されたら削除する
      // CO申請にPROCESS_PROGRESS_STATUS.DONEは存在しないためAGREEDの場合のみ非表示
      if (this.processType === PROCESS_TYPE.FDCOR
        && this.tradeManagement.processProgressStatus === PROCESS_PROGRESS_STATUS.AGREED) {
        return false;
      }

      return this.tradeManagement.actions.includes(PROCESS_OPERATION.F_PULL_BACK) || this.tradeManagement.actions.includes(PROCESS_OPERATION.T_PULL_BACK);
    },
    // Returnボタンの表示可否を返却します
    needReturnButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }
      // To担当者に表示
      return this.tradeManagement.actions.includes(PROCESS_OPERATION.T_RECONFIRMATION);
    },
    // Editボタンの表示可否を返却します
    // ブロックチェーン書き込み実行後・Delete後は非表示。担当者ロール以外のユーザーは非表示
    needEditButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }
      return this.tradeManagement.editAbleFlg === ABLE_FLG.TRUE;
    },
    // Registerボタンの表示可否を返却します
    // 非承認プロセス時 To担当者に表示
    needRegisterButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }
      return this.tradeManagement.actions.includes(PROCESS_OPERATION.T_DONE);
    },
    // Applyボタンの表示可否を返却します
    // 「承認プロセス」Delete申請時 To担当
    // 「承認プロセス」で通常の申請時 To担当者（To側にTo側限定の入力必須項目がない場合）
    //   →厳密に言うとプロセス変更画面にTo担当者の入力「必須」項目が無い場合だが、現状全部ない。
    needApplyButton() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }
      // 「承認プロセス」Delete申請時以外は非表示
      if (this.tradeManagement.responsibleFlg === RESPONSIBLE_FLG.FROM) {
        // Fromにボールがあるときは非表示
        return false;
      }
      // TO承認依頼が操作可能であれば表示
      return this.tradeManagement.actions.includes(PROCESS_OPERATION.T_APPROVE_REQ);
    },
    // 承認部品の表示可否を返却します
    needApprovalArea() {
      // アーカイブ閲覧時は非表示
      if (this.isArchive) {
        return false;
      }
      return this.tradeManagement.actions.includes(PROCESS_OPERATION.F_APPROVE) || this.tradeManagement.actions.includes(PROCESS_OPERATION.T_APPROVE) || this.tradeManagement.actions.includes(PROCESS_OPERATION.F_REMAND) || this.tradeManagement.actions.includes(PROCESS_OPERATION.T_REMAND);
    },
    // Applyボタンの表示可否を返却します
    editNeedApplyButton() {
      return this.tradeManagement.actions.includes(PROCESS_OPERATION.F_APPROVE_REQ) || this.tradeManagement.actions.includes(PROCESS_OPERATION.T_APPROVE_REQ);
    },
    // Saveボタンの表示可否を返却します
    editNeedSaveButton() {
      return this.tradeManagement.actions.includes(PROCESS_OPERATION.F_SAVING) || this.tradeManagement.actions.includes(PROCESS_OPERATION.T_SAVING);
    },
    // Registerボタンの表示可否を返却します
    editNeedRegisterButton() {
      return this.tradeManagement.actions.includes(PROCESS_OPERATION.F_DONE) || this.tradeManagement.actions.includes(PROCESS_OPERATION.T_DONE);
    },
    applyButtonLabel() {
      if (this.tradeManagement.responsibleFlg === RESPONSIBLE_FLG.TO) {
        return this.$t('Label.Apply(Awaiting Confirmation(To))');
      } else {
        return this.$t('Label.Apply(NotStarted/InputInProgress)');
      }
    },
    needMenuButton() {
      return (
        this.needReturnButton ||
        this.needWithdrawButton ||
        this.needCancelDeleteRequestButton ||
        this.needFromDeleteButton ||
        this.needToDeleteButton ||
        this.needDeleteSavedDataButton
      );
    }
  },
  methods: {
    edit() {
      this.isEditMode = true;
      this.s.mode = 'edit';
    },
    // 承認依頼
    approvalRequest() {
      const action = PROCESS_OPERATION.T_APPROVE_REQ;
      if (this.tradeManagement.eventCancel) {
        this.$store
          .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__ACTION_DELETE_REQUEST'))
          .then(() => {
            this.$emit('approval-request', action, this.createPostDocuments());
          })
          .catch(() => {});
      } else {
        this.$emit('approval-request', action, this.createPostDocuments());
      }
    },
    // 承認依頼
    editApprovalRequest() {
      this.documentsValidation()
      .then(() => {
        this.quantityOverAlert().then(() => {
          const action = this.tradeManagement.responsibleFlg === RESPONSIBLE_FLG.FROM ? PROCESS_OPERATION.F_APPROVE_REQ : PROCESS_OPERATION.T_APPROVE_REQ;
          this.$emit('approval-request', action, this.createPostDocuments());
        })
        .catch(() => {
          return false;
        });
      })
      .catch(() => {
        return false;
      });
      this.isEditMode = false;
    },
    register() {
      const action = this.tradeManagement.responsibleFlg === RESPONSIBLE_FLG.FROM ? PROCESS_OPERATION.F_DONE : PROCESS_OPERATION.T_DONE;
      if (this.tradeManagement.eventCancel && action === PROCESS_OPERATION.T_DONE) {
        this.$store
          .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__ACTION_DELETE_REQUEST'))
          .then(() => {
            this.$emit('register', action, this.createPostDocuments());
          })
          .catch(() => {});
      } else {
        this.$emit('register', action, this.createPostDocuments());
      }
    },
    // 登録
    editRegister() {
      this.documentsValidation()
      .then(() => {
        this.quantityOverAlert().then(() => {
          const action = this.tradeManagement.responsibleFlg === RESPONSIBLE_FLG.FROM ? PROCESS_OPERATION.F_DONE : PROCESS_OPERATION.T_DONE;
          this.$emit('register', action, this.createPostDocuments());
        })
        .catch(() => {
          return false;
        });
      })
      .catch(() => {
        return false;
      });
    },
    // 下書き保存
    editSave() {
      this.documentsValidation()
      .then(() => {
        this.quantityOverAlert().then(() => {
          const action = this.tradeManagement.responsibleFlg === RESPONSIBLE_FLG.FROM ? PROCESS_OPERATION.F_SAVING : PROCESS_OPERATION.T_SAVING;
          this.$emit('save',  action, this.createPostDocuments());
        })
        .catch(() => {
          return false;
        });
      })
      .catch(() => {
        return false;
      });
      this.isEditMode = false;
    },
    onDropDownClick(command) {
      if (command === 'return') {
        const action = PROCESS_OPERATION.T_RECONFIRMATION;
        this.$store
          .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__ACTION_RETURN'))
          .then(() => {
            this.$emit('withdraw', action);
          })
          .catch(() => {});
      } else if (command === 'withdraw') {
        const action = this.tradeManagement.actions.includes(PROCESS_OPERATION.F_PULL_BACK) ? PROCESS_OPERATION.F_PULL_BACK : PROCESS_OPERATION.T_PULL_BACK;
        this.$store
          .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__ACTION_WITHDRAW'))
          .then(() => {
            this.$emit('withdraw', action);
          })
          .catch(() => {});

      } else if (command === 'fromDeleteRequest') {
        this.$store
          .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__ACTION_DELETE_REQUEST'))
          .then(() => {
            // From削除申請、下書き削除
            this.$emit('delete-draft');
          })
          .catch(() => {});
      } else if (command === 'toDeleteRequest') {
        this.$store
          .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__ACTION_DELETE_REQUEST'))
          .then(() => {
            // To削除申請
            const action = PROCESS_OPERATION.T_SAVING_DEL;
            this.$emit('approval-request', action, this.createPostDocuments());
          })
          .catch(() => {});
      } else if (command === 'deleteSavedData') {
        // To下書き削除
        this.$store
          .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__ACTION_DELETE_REQUEST'))
          .then(() => {
            this.$emit('delete-draft');
          })
          .catch(() => {});
      } else if (command === 'cancelDeleteRequest') {
        this.$store
          .dispatch('SHOW_CONFIRM', this.$t('Message.CONFIRM__ACTION_CANCEL_DELETE_REQUEST'))
          .then(() => {
            const action = PROCESS_OPERATION.F_PULL_BACK;
            this.$emit('withdraw', action);
          })
          .catch(() => {});
      }
    },
    updateAttachedFiles() {
      this.$emit("update-attached-files");
    },
    reconfirm() {
      this.$emit('withdraw', PROCESS_OPERATION.T_RECONFIRMATION);
    },
    // 混載元フローの取引詳細を表示します
    showTradingDetails(flow) {
      this.$emit('show-trading-detail', flow);
    },
    changeVersion(version) {
      if (version !== this.tradeManagement.processTrx) {
        this.$emit('change-version', this.version);
      }
    },
    documentsValidation() {
      return new Promise((resolve, reject) => {
        this.$refs.simpleForm.validate((valid) => {
          if (valid) {
            resolve();
          } else {
            this.$store.dispatch('SHOW_ALERT', this.$t('Message.ERROR__INPUT_INVALID'));
            reject();
          }
        });
      });
    },
    // サブフローで親フローの商品の数量を超えていた場合のアラート
    async quantityOverAlert() {
      if (!this.isSubFlow) return Promise.resolve()
      let result = true
      if (this.localValue.linkageGoodsLine && this.parentGoodsLine.length) {
        _.forEach(this.parentGoodsLine, item => {
          // 親の合計数量
          const parentQuantity = item.quantityGrp.quantity1 || 0
          // 親と同じprevGoodsLineId、prevGoodsLineSeqを持つ子のグッズ
          const childGoods = _.filter(this.localValue.linkageGoodsLine, goods => {
            return goods.goodsGrp.prevGoodsLineId === item.goodsGrp.prevGoodsLineId && goods.goodsGrp.prevGoodsLineSeq === item.goodsGrp.prevGoodsLineSeq;
          })
          if (!childGoods || !childGoods.length) return
          // 子の数量合計
          const childQuantity = _.reduce(childGoods, (total, child) => {
            total = (child.quantityGrp.quantity1 || 0) + total
            return total;
          }, 0);
          if (parentQuantity < childQuantity) {
            result = false
            return false
          }
        });
      }
      if (result) return Promise.resolve()
      else {
        await this.$store.dispatch('SHOW_CONFIRM', this.$t('Message.ERROR__QUANTITY_EXCEEDED'))
          .then(() => { return Promise.resolve() })
          .catch(() => { return Promise.reject() })
      }
    },
    createPostDocuments() {
      return [];
    }
  }
};
</script>

<style lang="scss" scoped>
  .simple {
    display: flex;
  }
  .left_body {
    width: 32%;
    max-height: 800px;
  }
  .center_body {
    width: 40%;
    margin-left: 10px;
    margin-right: 10px;
    max-height: 800px;
  }
  .right_body {
    width: 28%;
    margin-left: auto;
    max-height: 800px;
  }
  .column {
    display: flex; 
    align-items:center;
  }
  .process_buton {
    margin-left: auto;
  }
</style>
